// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__ObUBf","footer":"NavbarSimple_footer__b0mFZ","link":"NavbarSimple_link__1lcBR","linkIcon":"NavbarSimple_linkIcon__43NaA"};